import { InputProjectInformationDialogState } from ".";

const fieldPath = {
  pjtName: "projectInformation.pjtName",
  pjtDesc: "projectInformation.pjtDesc",
  pjtStartPlnDate: "projectInformation.pjtStartPlnDate",
  pjtEndPlnDate: "projectInformation.pjtEndPlnDate",
  trnsMsnTypeCd: "projectInformation.trnsMsnTypeCd",
  ediUsage: "projectInformation.ediUsage",
  chnTypeGrpTypeCdList: "projectInformation.chnTypeGrpTypeCdList",
  reqEstmtAnsDueDate: "projectInformation.reqEstmtAnsDueDate",
};

const usageType = [
  { label: "Do Not Use", value: "DoNotUse" },
  { label: "Use", value: "Use" },
];

export const InputProjectInformationDialogInitialState: InputProjectInformationDialogState =
  {
    isShow: false,
    isCreate: false,
    saved: {},
    edited: {},
    codes: {
      trnsmsnType: [],
      chnTypeGrpType: [],
      usageType: usageType,
    },
    fieldPath: fieldPath,
    pjtId: "",
    updateDateTime: "",
    status: {
      ediUsage: "",
      invalidList: [],
      isSaved: false,
    },
  };
